const dataLayerName = 'dataLayer';

const initDataLayer = () => {
  window[dataLayerName] = window[dataLayerName] || [];
};

export const getDataLayer = () => {
  initDataLayer();
  return window[dataLayerName];
};

export const addDataLayerValue = (value) => {
  const dl = getDataLayer();
  dl.push(value);
  return dl;
};

export function handleClickTrackingSignUp() {
  /** Emitting GA event when clicking sign up on a college event */
  addDataLayerValue({
    event: 'trackSignUp',
    eventCategory: 'User Engagement',
    eventAction: 'signup-button-clicked',
  });
}

export function handleClickTrackingCollegeName() {
  /** Emitting GA event when clicking a college name */
  addDataLayerValue({
    event: 'trackCollegeNameClick',
    eventCategory: 'User Engagement',
    eventAction: 'college-name-link-clicked',
  });
}

export function trackPageVisit() {
  /** Emitting GA event when user visits College Events */
  addDataLayerValue({
    event: 'trackCollegeEventVisit',
    eventCategory: 'User Engagement',
    eventAction: 'track-page-visit',
  });
}
